import { render, staticRenderFns } from "./EditWebhookForm.vue?vue&type=template&id=1b39e1e4&"
import script from "./EditWebhookForm.vue?vue&type=script&lang=js&"
export * from "./EditWebhookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports